//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import Sessie from './Sessies/Sessie.vue';
import NewSessie from './Sessies/NewSessie.vue';
import EditSessie from './Sessies/EditSessie.vue';
export default {
  name: 'Sessies',
  components: {
    Sessie,
    NewSessie,
    EditSessie,
  },
  props: {
    expert: String,
    ajax: String,
  },
  data: function(){
    return {
      page: 1,
      max_num_pages: 1,
      new_sessie: false,
      edit_sessie: false,
      selected_id: '',
      sessies: [],
    };
  },
  methods: {
    handleSelect: function(id){
      this.new_sessie = false;
      this.edit_sessie = false;
      this.selected_id = id;
    },
    handleNew: function(){
      this.new_sessie = true;
      this.edit_sessie = false;
      this.selected_id = '';
    },
    handleEdit: function(id){
      this.new_sessie = false;
      this.edit_sessie = true;
      this.selected_id = id;
    },
    getSessies: function(){
      const self = this;
      axios.get(`${this.ajax}?action=sessies&expert=${this.expert}&paged=${this.page}`).then(res => {
        const { sessies, max_num_pages } = res.data;
        self.sessies = sessies;
        self.max_num_pages = max_num_pages;
      }).catch(error => {
        console.log(error);
      });
    },
    handleSuccess: function(id = ''){
      this.getSessies();
      this.new_sessie = false;
      this.edit_sessie = false;
      this.selected_id = id;
    },
    handlePagination: function(page){
      if(page === 'next'){
        this.page++;
      } else if(page === 'prev'){
        this.page--;
      } else {
        this.page = page;
      }
      if(this.page < 1){
        this.page = 1;
      }
      if(this.page > this.max_num_pages){
        this.page = this.max_num_pages;
      }
      this.getSessies();
    },
  },
  mounted: function(){
    this.getSessies();
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/Sessies.vue